import React from "react";
import {
  getAlleleFrequency,
  getAlleleValue,
} from "../../../../../../../common/helpers/helpers";
import { getFrequencyStyle } from "../../helpers";

export const getHistogramsData = (item) => {
  return Object.entries(item).reduce(
    (result, [key, value]) => {
      if (key.includes("age_hist_het")) {
        result.ageHistHetData[key] = value;
      } else if (key.includes("age_hist_hom")) {
        result.ageHistHomData[key] = value;
      }
      return result;
    },
    { ageHistHetData: {}, ageHistHomData: {} }
  );
};

export const getPopulationMainRowData = (item, suffix, isMito) => {
  const alleleNumber = getAlleleValue(item, "an", suffix);
  const alleleCount = getAlleleValue(item, "ac", suffix);
  const homoplasmicOrHomozygotes = isMito
    ? getAlleleValue(item, "ac", `${suffix}_hom`)
    : getAlleleValue(item, "nhomalt", suffix);
  const heteroplasmic = isMito
    ? getAlleleValue(item, "ac", `${suffix}_het`)
    : null;
  let hemizygotes = null;

  if (item?.nonpar === 1) {
    const maleAlleleValue = getAlleleValue(item, "ac", `${suffix}_male`);
    hemizygotes = maleAlleleValue
      ? maleAlleleValue.toLocaleString().replace(",", " ")
      : "-";
  } else if (item?.nonpar !== 1) {
    hemizygotes = "-";
  }
  const alleleFrequencyStyle = getFrequencyStyle(alleleCount, alleleNumber);
  const alleleFrequency =
    alleleCount && alleleNumber
      ? getAlleleFrequency(
          alleleCount / alleleNumber,
          3,
          alleleFrequencyStyle.color,
          alleleFrequencyStyle.weight
        )
      : null;

  return {
    alleleNumber,
    alleleCount,
    homoplasmicOrHomozygotes,
    heteroplasmic,
    hemizygotes,
    alleleFrequency,
  };
};

export const renderColumn = (label, value, styleClass = "") => (
  <td className={`${styleClass}`} data-testid={`${label}`}>
    {value !== null && value !== undefined
      ? value.toLocaleString().replaceAll(",", " ")
      : !label.includes("empty-column") &&
        !label.includes("row-label") &&
        " - "}
  </td>
);
